import { EventEmitter } from 'events';
import assign from 'object-assign';
import { findIndex, reject } from 'lodash';
import ToastStore from 'stores/ToastStore';
import i18next from 'i18next';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
let accessorialRates = [];
let accessorialRate = {};
function toast(message, level) {
    if (!level)
        level = 'error';
    ToastStore.getNotifications().push({
        title: message,
        body: '',
        level: level,
    });
    ToastStore.emitChange();
}
const AccessorialRatesStore = assign({}, EventEmitter.prototype, {
    defaults: {
        status: false,
        error: false,
        isAddOrRemove: false,
    },
    reset() {
        this.status = false;
        this.error = false;
        this.isAddOrRemove = false;
    },
    getStatus() {
        return this.status;
    },
    getError() {
        return this.error;
    },
    clearAll() {
        accessorialRates = [];
        accessorialRate = {};
        this.reset();
    },
    getIsAddOrRemove() {
        return this.isAddOrRemove;
    },
    setIsAddOrRemove() {
        this.isAddOrRemove = false;
    },
    getAccessorialRateIndex(accessorialRate) {
        return findIndex(accessorialRates, {
            _id: accessorialRate._id,
        });
    },
    getAccessorialRates() {
        return accessorialRates || [];
    },
    getAccessorialRate() {
        return accessorialRate || {};
    },
    receiveAccessorialRates(data) {
        accessorialRates = data;
        this.status = 'success';
    },
    receiveAccessorialRate(data) {
        accessorialRate = data;
        this.status = 'success';
    },
    receiveAddAccessorialRateSuccess(data) {
        accessorialRate = data.accessorialRate;
        if (accessorialRate)
            accessorialRates.push(accessorialRate);
        this.status = 'success';
        this.isAddOrRemove = true;
        toast(i18next.t('NEW_ACCESSORIAL_RATE_ADDED'), 'success');
    },
    receiveUpdateAccessorialRateSuccess(data) {
        accessorialRate = data;
        if (accessorialRate) {
            const idx = this.getAccessorialRateIndex(accessorialRate);
            if (idx < accessorialRates.length) {
                accessorialRates[idx] = accessorialRate;
            }
        }
        this.status = 'success';
        toast(i18next.t('ACCESSORIAL_RATE_UPDATED'), 'success');
    },
    receiveUpdateAccessorialRateFail(data) {
        this.status = 'fail';
        this.error = data.entity;
        toast(i18next.t('ACCESSORIAL_RATE_UPDATE_FAILED'), 'error');
    },
    receiveRemoveAccessorialRateSuccess(data) {
        toast(i18next.t('ACCESSORIAL_RATE_REMOVED'), 'success');
        accessorialRate = data;
        if (accessorialRate) {
            accessorialRates = reject(accessorialRates, function (item) {
                return item._id === accessorialRate._id;
            });
        }
        this.status = 'success';
        this.isAddOrRemove = true;
    },
    receiveRemoveAccessorialRateFail(data) {
        this.status = 'fail';
        this.isAddOrRemove = false;
        this.error = data.entity;
        toast(i18next.t('ACCESSORIAL_RATE_REMOVE_FAILED'), 'error');
    },
    emitChange() {
        this.emit('change');
    },
    addChangeListener(callback) {
        this.on('change', callback);
    },
    removeChangeListener(callback) {
        this.removeListener('change', callback);
    },
});
AccessorialRatesStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_ACCESSORIALRATES:
            AccessorialRatesStore.receiveAccessorialRates(action.data);
            AccessorialRatesStore.emitChange();
            break;
        case ActionTypes.RECEIVE_ACCESSORIALRATE:
            AccessorialRatesStore.receiveAccessorialRate(action.data);
            AccessorialRatesStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIALRATE_SUCCESS:
            AccessorialRatesStore.receiveUpdateAccessorialRateSuccess(action.data);
            AccessorialRatesStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIALRATE_FAIL:
            AccessorialRatesStore.receiveUpdateAccessorialRateFail(action.data);
            AccessorialRatesStore.emitChange();
            break;
        case ActionTypes.REMOVE_ACCESSORIALRATE_SUCCESS:
            AccessorialRatesStore.receiveRemoveAccessorialRateSuccess(action.data);
            AccessorialRatesStore.emitChange();
            break;
        case ActionTypes.REMOVE_ACCESSORIALRATE_FAIL:
            AccessorialRatesStore.receiveRemoveAccessorialRateFail(action.data);
            AccessorialRatesStore.emitChange();
            break;
        case ActionTypes.ADD_ACCESSORIALRATE_SUCCESS:
            AccessorialRatesStore.receiveAddAccessorialRateSuccess(action.data);
            AccessorialRatesStore.emitChange();
            break;
        default:
            break;
    }
});
export default AccessorialRatesStore;
